export default __webpack_public_path__ + "static/media/accessible.e968e355.svg";